import axios from '@/plugins/axios';
import ErrorHandle from '@/helpers/errors/errorHandle';

const initialState = {
  isAuthenticated: !!localStorage.getItem('token') || false,
};
const getters = {
  isAuthenticated: (state) => state.isAuthenticated,
};

const mutations = {
  setAuthenticated(state, data) {
    state.isAuthenticated = data;
  },
};

/* eslint-disable no-unused-vars */
const actions = {
  async forgotPassword({ commit }, credentials) {
    try {
      const lang = localStorage.getItem('language') || '';
      const data = await axios.post('/user/password/forgot', credentials, {
        headers: { Lang: lang },
      });

      commit('setAuthenticated', false);
      return data;
    } catch (error) {
      return error.response;
    }
  },
  async setPassword({ commit }, setData) {
    try {
      const lang = localStorage.getItem('language') || '';
      const data = await axios.put(
        '/user/password/reset',
        JSON.stringify(setData),
        {
          headers: { Lang: lang },
        },
      );

      commit('setAuthenticated', false);
      return data;
    } catch (error) {
      return error.response;
    }
  },
  async login({ commit, dispatch }, credentials) {
    try {
      const lang = localStorage.getItem('language') || '';
      const { data } = await axios.post(
        '/user/auth',
        JSON.stringify(credentials),
        {
          headers: { Lang: lang },
        },
      );

      const { accessToken } = data.data;

      localStorage.setItem('token', accessToken);
      commit('setAuthenticated', true);

      await dispatch('getMyInfo');

      return data;
    } catch (error) {
      throw ErrorHandle(error, this);
    }
  },
  async getMyInfo({ commit }) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      const { data } = await axios.get('users/me', {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });
      if (data.data.tasks && data.data.tasks.length) {
        // prepare notification cards
        data.data.tasks.forEach((task) => {
          const taskData = JSON.parse(task.data);
          const notificationsData = {
            id: task.id,
            type: task.type,
            level: taskData.level,
            data: taskData.data,
          };
          commit('user/setUserNotification', notificationsData, { root: true });
        });
      }
      localStorage.setItem('me', JSON.stringify(data.data));
      await commit('global/setRole', null, { root: true });

      return data;
    } catch (error) {
      throw ErrorHandle(error, this);
    }
  },
  logOut({ commit }) {
    localStorage.removeItem('token');
    commit('setAuthenticated', false);
    localStorage.removeItem('me');
    commit('global/setRole', null, { root: true });
  },
  /* eslint-disable no-unused-vars */
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  mutations,
  actions,
};
